
import { Content } from '../../../components/Basic/Global';
import { H1 } from '../../../components/Basic/WrapsStyle';
import ReviewsTable from './Table';

const ReviewsPage = () => {
  return (
      <Content>
        <H1>Проверка отзывов</H1>
        <ReviewsTable />
      </Content>
  );
};

export default ReviewsPage;
